import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ErrorService } from '@cosmos/angular/utils';
import { QuotaTransaction } from '@cosmos/shared';
import { catchError, map, Observable } from 'rxjs';
import { environment } from '../../../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class QuotaTransactionsService {

  constructor(
    private http: HttpClient,
    private errorService: ErrorService,
  ) {}

  findByProject(projectId: string): Observable<HttpResponse<QuotaTransaction[]>> {
    return this.http
      .get<QuotaTransaction[]>(`${environment.API_URL}/quota-transactions/project/${projectId}`, { observe: 'response' })
      .pipe(
        map(r => r),
        catchError(e => { this.errorService.handleError(e); throw e; })
      );
  }
}
